<div class="filter-container position-relative w-100">
  <app-filter-search
    class="filter-dropdown"
    [placeholder]="(translationScope+'.filters.search' | transloco)"
    [value]="instructorFilter?.search"
    (search)="updateSearchFilter($event)"
  ></app-filter-search>

  <div *ngIf="categories"
    app-filter-dropdown
    class="category-filter"
    [items]="categories"
    [showSelectionCount]="true"
    [(selectedItems)]="selectedCategories"
    [placeholder]="translationScope + '.filters.categories' | transloco"
    [bindLabel]="'title'"
    [bindValue]="'id'"
    (close)="updateCategoriesFilter()"
    (clear)="clearCategoriesFilter()"
  ></div>

  <div *ngIf="templates"
    app-filter-dropdown
    class="template-filter"
    [items]="templates"
    [showSelectionCount]="true"
    [(selectedItems)]="selectedTemplates"
    [placeholder]="(translationScope+'.filters.templates' | transloco)"
    [bindLabel]="'title'"
    [bindValue]="'id'"
    (close)="updateTemplatesFilter()"
  ></div>

  <div *ngIf="regions"
    app-filter-dropdown
    class="region-filter"
    [items]="regions"
    [showSelectionCount]="true"
    [(selectedItems)]="selectedRegions"
    [placeholder]="translationScope + '.filters.regions' | transloco"
    [bindLabel]="'name'"
    [bindValue]="'id'"
    (close)="updateRegionsFilter()"
  ></div>

  <div class="reset-filter" (click)="resetFiltersAndSearch()">
    <img src="assets/icons/refresh.svg" alt="">
    <span>{{ translationScope + '.filters.reset' | transloco }}</span>
  </div>
</div>

<button class="filter-button" (click)="openFilterBottomSheet()" [disabled]="!isFiltersLoaded">
  <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
  <span>{{ 'Filters' }}</span>
  <div *ngIf="activeFilterCount > 0" class="bg-selection-count">
    <span class="selection-count">{{ activeFilterCount }}</span>
  </div>
</button>

